import { render, staticRenderFns } from "./FinancialComponent.vue?vue&type=template&id=68183de2&scoped=true&"
import script from "./FinancialComponent.vue?vue&type=script&lang=js&"
export * from "./FinancialComponent.vue?vue&type=script&lang=js&"
import style0 from "./FinancialComponent.vue?vue&type=style&index=0&id=68183de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68183de2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow,VSimpleTable})
